import { Component, OnInit, Input } from '@angular/core'

@Component({
  selector: 'dmmp-icons-text',
  templateUrl: './icons-text.component.html'
})
export class IconsTextComponent implements OnInit {
  @Input() data
  constructor() {}

  ngOnInit() {}
}
